import { Enum } from "../../types/types";

export const CommonLocators = Enum(
  "datePicker_select_month",
  "datePicker_select_day",
  "datePicker_select_year",
  "input_errorMessage",
  "toast_message"
);
